/*
 * Copyright (c) Fing Ltd. All rights reserved.
 */

import React, {Component} from 'react';
import intl from 'react-intl-universal';

import {roundPercentile} from "../../helpers/IspScoreHelper";

import {getCountryName} from "../place/GeoCountries";

export default class IspRankSummary extends Component {

    rankString(score) {
        let SCORE_ROUND_FACTOR = 5.0;
        if (score >= 55.0) {
            return intl.get('isp_rank_top', {rank: roundPercentile((100.0 - score), SCORE_ROUND_FACTOR)});
        } else if (score <= 45.0) {
            return intl.get('isp_rank_bottom', {rank: roundPercentile(score, SCORE_ROUND_FACTOR)});
        } else {
            return intl.get('isp_rank_average');
        }
    }

    relevantTrend(trend) {
        if (!trend) return false;
        return (trend>=0.03 || trend<=-0.03);
    }

    trendString(trend) {
        if (trend>=0.15) return intl.get('isp_trend_vbetter');
        else if (trend>=0.03) return intl.get('isp_trend_better');
        else if (trend<=-0.15) return intl.get('isp_trend_vworse');
        else if (trend<=-0.03) return intl.get('isp_trend_worse');
        else  return "";
    }

    render() {
        const cName = this.props.className || 'small text-muted';
        return (
            <span className={cName}>{this.rankString(this.props.score)} {
                this.props.isp.countryCity ? this.props.isp.countryCity :
                    this.props.isp.countryRegion ? this.props.isp.countryRegion :
                        getCountryName(this.props.isp.countryCode)
            }

            {
                this.relevantTrend(this.props.trend) &&
                ', '+this.trendString(this.props.trend)

            }</span>
        );
    }
}